<template>
    <div>   
        <div class="cards-scroller mt-5" >
            <div class="cards-scroller-crop">
                <div class="cards-scroller-content scrollt" :id="`scrollerX${category}`" @scroll="goScroll" >
                    <div class="cards-scroller-platter">
                        
                        <v-slide-item class="cards-scroller-snap container-hover" v-for="(item, index) in data" :key="index"  v-slot="{ active, toggle }">
                                <v-card :ripple="{ class: 'brown--text  text--lighten-3' }" class=""  :class="mode == 'session' ? 'cards-scroller-itemview-new-tramite zoom-on-hover-slider-new-tramite' : 'cards-scroller-itemview zoom-on-hover-slider'"  flat  plain tile  :color="mode == 'session' ? 'success-nl' : ''" @click="toggle">
                                    <div class="ccard rf-ccard-40">
                                        <!-- mode  session es el comportamiento cuando tiene la session iniciada xd -->
                                        <router-link  v-if="mode=='session' && !item.url" :to="{ name: 'procedure_create', params: { processId: item.id }}" class="text-decoration-none no1">
                                            <div  style="cursor:pointer" >
                                                <div  :class="mode=='session' ? 'card-content-scroll-new-tramites' : 'card-content-scroll' " >
                                                    <div class="w-100 mt-7" >
                                                        <!-- {{item.icon}} -->
                                                                <!-- <img width="400" height="500" alt="" class="rf-ccard-img-full" style="width: 100%;height: 100%;object-fit: cover;display: block;"> -->
                                                                    <v-img v-if="item.icon"
                                                                    active-class="success-nl"
                                                                    class="mx-auto  align-self-baseline  "
                                                                    plain
                                                                    style="width: 50%;height: 50%;object-fit: cover;display: block;margin-top:40%"
                                                                    contain
                                                                    min-width="60%"
                                                                    max-width="60%"
                                                                    :lazy-src="require(`../../assets/img/maletin-default.webp`)"
                                                                    :src="item.icon"
                                                                    />  
                                                                    <v-img v-else
                                                                    active-class="success-nl"
                                                                    class="mx-auto  align-self-baseline  "
                                                                    plain
                                                                    style="width: 50%;height: 50%;object-fit: cover;display: block;margin-top:40%"
                                                                    contain
                                                                    min-width="60%"
                                                                    max-width="60%"
                                                                    :lazy-src="require(`../../assets/img/maletin-default.webp`)"
                                                                    :src="require(`../../assets/img/maletin-default.webp`)"
                                                                    />  
                                                                    <!-- :src="require(`../../assets/img/${item.img}`)"  -->
                                                    </div>
                                                    <div class="ccard-content-info" >
                                                        <h3 class="ccard-content-eyebrow" >{{item.tiempo_entrega }} </h3>
                                                        <div class="ccard-content-header" >
                                                            <span style="color: #1d1d1f;text-decoration: none;display: inline-block;" >{{item.text || item.nombre }}  </span>
                                                        </div>
                                                        <div class="ccard-content-desc" >{{item.subtitle || item.costo}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </router-link>
                                        <!-- los tramites que son externos -->
                                        <a  v-else-if="item.url" :href="item.url"   target="_blank" class="text-decoration-none no2">
                                            <div  style="cursor:pointer" >
                                                <div  :class="mode=='session' ? 'card-content-scroll-new-tramites' : 'card-content-scroll' " >
                                                    <div class="w-100 mt-16" >
                                                        <!-- {{item.icon}} -->
                                                                <!-- <img width="400" height="500" alt="" class="rf-ccard-img-full" style="width: 100%;height: 100%;object-fit: cover;display: block;"> -->
                                                                    <v-img v-if="item.icon"
                                                                    active-class="success-nl"
                                                                    class="mx-auto  align-self-baseline  "
                                                                    plain
                                                                    style="width: 50%;height: 50%;object-fit: cover;display: block;margin-top:40%"
                                                                    contain
                                                                    min-width="70%"
                                                                    max-width="70%"
                                                                    :lazy-src="require(`../../assets/img/maletin-default.webp`)"
                                                                    :src="item.icon"
                                                                    />  
                                                                    <v-img v-else
                                                                    active-class="success-nl"
                                                                    class="mx-auto  align-self-baseline  "
                                                                    plain
                                                                    style="width: 50%;height: 50%;object-fit: cover;display: block;margin-top:40%"
                                                                    contain
                                                                    min-width="70%"
                                                                    max-width="70%"
                                                                    :lazy-src="require(`../../assets/img/maletin-default.webp`)"
                                                                    :src="require(`../../assets/img/maletin-default.webp`)"
                                                                    />  
                                                                    <!-- :src="require(`../../assets/img/${item.img}`)"  -->
                                                    </div>
                                                    <div class="ccard-content-info" >
                                                        <h3 class="ccard-content-eyebrow" >{{item.tiempo_entrega }} </h3>
                                                        <div class="ccard-content-header" >
                                                            <span style="color: #1d1d1f;text-decoration: none;display: inline-block;" >{{item.text || item.nombre }}  </span>
                                                        </div>
                                                        <div class="ccard-content-desc" >{{item.subtitle || item.costo}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                        
                                        <!-- sin sesion iniciada -->
                                        <router-link  v-else :to=" item.invited != 0 ? { name: 'process_requirement',  params: { processId: item.id, processName: item.nombre}, query: {invited: item.invited}} : { path: '/login' } " class="text-decoration-none no3">
                                            <div  style="cursor:pointer" >
                                                <div  :class="mode=='session' ? 'card-content-scroll-new-tramites' : 'card-content-scroll' " >
                                                    <div class="w-100 mt-16" >
                                                        <!-- {{item.icon}} -->
                                                                <!-- <img width="400" height="500" alt="" class="rf-ccard-img-full" style="width: 100%;height: 100%;object-fit: cover;display: block;"> -->
                                                                    <v-img v-if="item.icon"
                                                                    active-class="success-nl"
                                                                    class="mx-auto  align-self-baseline  "
                                                                    plain
                                                                    style="width: 50%;height: 50%;object-fit: cover;display: block;margin-top:40%"
                                                                    contain
                                                                    min-width="60%"
                                                                    max-width="60%"
                                                                    :lazy-src="require(`../../assets/img/maletin-default.webp`)"
                                                                    :src="item.icon"
                                                                    />  
                                                                    <v-img v-else
                                                                    active-class="success-nl"
                                                                    class="mx-auto  align-self-baseline  "
                                                                    plain
                                                                    style="width: 50%;height: 50%;object-fit: cover;display: block;margin-top:40%"
                                                                    contain
                                                                    min-width="70%"
                                                                    max-width="70%"
                                                                    :lazy-src="require(`../../assets/img/maletin-default.webp`)"
                                                                    :src="require(`../../assets/img/maletin-default.webp`)"
                                                                    />  
                                                                    <!-- :src="require(`../../assets/img/${item.img}`)"  -->
                                                    </div>
                                                    <div class="ccard-content-info" >
                                                        <h3 class="ccard-content-eyebrow" >{{item.tiempo_entrega }} </h3>
                                                        <div class="ccard-content-header" >
                                                            <span style="color: #1d1d1f;text-decoration: none;display: inline-block;" >{{item.text || item.nombre }}  </span>
                                                        </div>
                                                        <div class="ccard-content-desc" >{{ item.costo}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </router-link>


                                        <router-link  v-if="mode == 'session' && !item.url " style="z-index:4;margin-top: -12%;right:4%;position:absolute" :to="{ name: 'process_requirement', params: { processId: item.id, processName: item.nombre}, query:{invited: item.invited}}" class="text-decoration-none">
                                            <v-btn depressed >
                                                más información
                                            </v-btn>
                                        </router-link>
                                        
                                    </div>
                                </v-card>
                        </v-slide-item>
                                                  
                    </div>
                </div>
            </div>
        </div>
        <div class="arrow-container d-flex  justify-space-between paddlenav-framed paddlenav-compact">
            <div>
                <v-btn v-show="canGoleft"
                    elevation="2"
                    icon
                    width="50px"
                    height="50px"
                    class="my-auto ml-5 arrow-left "
                    @click="goLeft"
                    
                >
                    <v-icon dark>
                        mdi-arrow-left-circle                
                    </v-icon>
                </v-btn>
            </div>
            <div>
                <v-btn
                    v-if="canGoRight"
                    elevation="2"
                    icon
                    width="50px"
                    height="50px"
                    class="my-auto mr-5 arrow-right "
                    @click="goRight"
                >
                    <v-icon dark>
                        mdi-arrow-right-circle                
                    </v-icon>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data', 'mode' , 'category'],
    data(){
        return{
            scrollerX :'',
            canGoleft:  false,
            canGoRight: true,
        }
    },
    mounted(){
        // document.addEventListener()
        // console.log(this.mode);
    },
    methods: {
        goRight(){
            this.scrollerX = document.getElementById(`scrollerX${this.category}`);
            this.scrollerX.scrollLeft = this.scrollerX.scrollLeft + 400
        },
        goLeft(){
            this.scrollerX = document.getElementById(`scrollerX${this.category}`);
            this.scrollerX.scrollLeft = this.scrollerX.scrollLeft - 400
        },
        goScroll(e){
            var maxScrollLeft = e.target.scrollWidth - e.target.clientWidth;
            e.target.scrollLeft == 0 ? this.canGoleft = false : this.canGoleft = true;
            e.target.scrollLeft == maxScrollLeft ? this.canGoRight = false : this.canGoRight = true;

        },
        gotoDetalles(id, nombre){
            // name: 'procedure_create', processId: item.id processName: item.nombre
            this.$router.push({name: 'procedure_create', processId: id, processName: nombre})
        }
    }
}
</script>

<style scoped >

.container-hover{
    -webkit-transition: transform .4s ease-in-out;
    
}

.zoom-on-hover-slider-new-tramite:hover{
    transform: scale(1.009) !important;
    z-index: 10;
    border-radius: 5px;
    box-shadow: 0 8px 10px -6px rgba(0, 0, 0, 0.76) !important;
} 

/* -webkit-transition: transform .6s ease-in-out; */

.zoom-on-hover-slider:hover{
    transform: scale(1.009) translateX(calc(max(1024px, 100vw)/2 - 495px))  ;
    z-index: 99;
    border-radius: 5px;
    box-shadow: 0 1px 14px -11px rgb(0 0 0 / 77%) !important;
}

.arrow-container{
    margin-top: -17rem;
    width: 100%;
    list-style: none;
    height: 0px;
    position: absolute;
    z-index: 200;
    background-color: transparent;
}

.pantone--test{
    color: #fff5d3 !important;
    caret-color: #fff5d3 !important;
}

.ccard{
    border-radius: 10px;
}
.cards-scroller{
    position: relative;
}
.cards-scroller-crop{
    overflow: hidden;
    height: 520px;
    padding-bottom: 26px;
    /*means: animate .scrollLeft and .scrollTop */
  
}
.cards-scroller-content{
    overflow-x: scroll;
    overscroll-behavior-x: contain;
    scroll-behavior: smooth;
    
}

.cards-scroller-platter{
    width: 400px;
    vertical-align: top;
    display: inline-flex;
    padding-top: 10px;
    padding-bottom: 40px;
    height: 560px;
}

.cards-scroller-snap{
    display: inline-block;
    scroll-snap-coordinate: left;
    scroll-snap-align: start;
}
.cards-scroller-itemview-new-tramite{
    margin-left: 0;
    display: flex;
    height: 500px;
    width: 400px !important;
    margin-right: 30px;
    border-radius: 10px !important;
    transform: unset ;
}

.cards-scroller-itemview{
    margin-left: 0;
    display: flex;
    height: 500px;
    margin-right: 30px;
    border-radius: 10px !important;
    transform: translateX(calc(max(1024px, 100vw)/2 - 490px));
}

.cards-scroller-itemview-new-tramite:focus{
    margin-left: 0;
    display: flex;
    height: 500px;
    margin-right: 20px;
    border-radius: 10px !important;
    /* transform: translateX(calc(max(1024px, 100vw)/2 - 490px)); */
}
.cards-scroller-itemview:focus{
    margin-left: 0;
    display: flex;
    height: 500px;
    margin-right: 20px;
    border-radius: 10px !important;
    transform: translateX(calc(max(1024px, 100vw)/2 - 490px));
}
.v-card--link:before{
    background: #fff5d3 !important;
    border-radius: 10px;
}
.card-content-scroll{
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background-color: transparent;
    border-radius: 18px;
    width: 400px;
    height: 500px;
    white-space: normal;
    box-shadow: 2px 4px 12px rgb(0 0 0 / 8%);transition: all .3s cubic-bezier(0,0,.5,1);
}
.card-content-scroll-new-tramites{
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background-color:#fff5d3;
    border-radius: 18px;
    width: 400px !important;
    height: 500px;
    white-space: normal;
    box-shadow: 2px 4px 12px rgb(0 0 0 / 8%);transition: all .3s cubic-bezier(0,0,.5,1);
}
.ccard-content-info{
    position: absolute;
    left: 1.5rem;
    top: 1.5rem;
    right: 1.5rem
}
.ccard-content-eyebrow{
    font-size: 12px;
    line-height: 1;
    font-weight: 400;
    letter-spacing: -.01em;
    font-family: SF Pro Text,SF Pro Icons,AOS Icons,Helvetica Neue,Helvetica,Arial,sans-serif;
    font-weight: 600;
    color: #ff8400;
    /* width: 204px; */
    padding-bottom: 8px;
    display: block;
    margin-bottom: 0.4em;
    font-family: 'PoppinsRegular';
}
.ccard-content-header{
    font-size: 26px;
    padding-right: 10px;
    line-height: 1.14286;
    font-weight: 600;
    letter-spacing: .007em;
    letter-spacing: 1px;
    font-family: SF Pro Display,SF Pro Icons,AOS Icons,Helvetica Neue,Helvetica,Arial,sans-serif;
    color: #15212F;
}
.ccard-content-desc{
    font-size: 15px;
    line-height: 1.23536;
    font-weight: 400;
    letter-spacing: -.022em;
    font-family: SF Pro Text,SF Pro Icons,AOS Icons,Helvetica Neue,Helvetica,Arial,sans-serif;
    color: rgb(107, 107, 107);
    padding-top: 10px;
    margin-top: 0;
}
.success-nl{
    background-color: #fff5d3  !important;
    color: darkorange !important;
}

@media only screen and (max-width:770px) {
    .card-content-scroll{
        /* width: 375px;
        height: 420px; */
        margin: 0rem  0rem;
        /* width: 100%; */

    }
    .cards-scroller-itemview:focus{
        /* height: 420px; */
    }
    .cards-scroller-itemview{
        /* height: 420px; */
    }
}
</style>
